import { render } from "./dashboardcard.vue?vue&type=template&id=62f9b146"
import script from "./dashboardcard.vue?vue&type=script&lang=js"
export * from "./dashboardcard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-admin-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__